import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route, useRouteMatch } from 'react-router-dom';
import Home from "./pages/Home/Home";
//import Event from "./pages/Event/Event";
import Event from "./pages/Event/EventNew";
import EventLivePanel from "./pages/Event/EventLivePanel";
import EventLiveTimes from './pages/Event/EventLiveTimes';
// import Publicidad1 from "./components/Banner/AuspiciantesApp";
import Publicidad1 from "./components/Banner/AuspiciantesAppAutomotor";

//import "./components/Banner/Auspiciantes.css"

// Códigos de evento en los que NO se muestra el banner de publicidad
const EVENTOS_SIN_BANNER = ['112', '112'];

// Rutas que nunca muestran el banner, sin importar el evento
const RUTAS_SIN_BANNER = [
  '/eventlivepanel/:id',
  '/eventlivetimes/:id'
];

function BannerPublicidad() {
  const matchLive = useRouteMatch(RUTAS_SIN_BANNER);
  const matchEvento = useRouteMatch('/event/:id');

  if (matchLive) {
    return null;
  }

  const eventId = matchEvento ? matchEvento.params.id : null;

  if (eventId && EVENTOS_SIN_BANNER.includes(String(eventId))) {
    return null;
  }

  return (
    <div className='carousel-wrapper'>
      <Publicidad1 />
    </div>
  );
}

function App() {
  return (

    <BrowserRouter>

    <div className='page-container'>
      <div className='main-content'>
        <Switch>
          <Route path='/' component={Home} exact />
          <Route path='/event/:id' component={Event} exact />
          <Route path='/eventlivepanel/:id' component={EventLivePanel} exact />
          <Route path='/eventlivetimes/:id' component={EventLiveTimes} exact />
        </Switch>
      </div>

      {/* Carousel en la parte inferior */}
      <BannerPublicidad />
    </div>

    </BrowserRouter>

  );
}

export default App;
